const booking = {
  bookingInformation: "Thông tin đặt chỗ", // translated 
  cancellationPolicy: "Chính sách hủy bỏ", // translated 
  ourCancellationPolicy: "Chính sách hủy đặt phòng của chúng tôi", // translated 
  thisAupersedesAnyCancellationPolicyInRemarksAbove:
    "Điều này thay thế mọi chính sách hủy bỏ được nêu ở trên.", // translated 
  thisBookingIsNonNefundable: "Đặt phòng này không được hoàn tiền.", // translated 
  paymentTerms: "Điều khoản thanh toán", // translated 
  paymentWillBeTakenFromYourDefault: "Tiền sẽ được trừ từ tài khoản mặc định của bạn.", // translated 
  paymentMethod: "phương thức thanh toán", // translated 
  afterTheFreeCancellationPeriodIfApplicable:
    "sau thời gian hủy miễn phí (nếu có).", // translated 
  prebook: "Đặt trước", // translated 
  guests: "Khách", // translated 
  payment: "Sự chi trả", // translated 
  byClicking: "Bằng cách nhấp chuột", // translated 
  youAreAgreeingToOur: "Bạn đồng ý với các điều khoản của chúng tôi.", // translated 
  termsAndConditions: "Điều khoản và điều kiện", // translated 
  lastBookableDate: "Ngày cuối cùng có thể đặt chỗ", // translated 
  customerRemarksTextfield: "Nhận xét của khách hàng", // translated 
  request: "Lời yêu cầu", // translated 
};


export default booking;
